__turbopack_context__.v({
  "groupBox": "entry-group-module-scss-module__GRuQTG__groupBox",
  "groupChevron": "entry-group-module-scss-module__GRuQTG__groupChevron",
  "groupCount": "entry-group-module-scss-module__GRuQTG__groupCount",
  "groupHeader": "entry-group-module-scss-module__GRuQTG__groupHeader",
  "groupLabel": "entry-group-module-scss-module__GRuQTG__groupLabel",
  "scrollArea": "entry-group-module-scss-module__GRuQTG__scrollArea",
  "statusDot": "entry-group-module-scss-module__GRuQTG__statusDot",
});
